import React, { useEffect, useState } from 'react'
import * as EmailValidator from 'email-validator'
import axios from 'axios'

const Form = () => {

	const [firstName, setFirstName] = useState('')
	const [lastName, setLastName] = useState('')
	const [email, setEmail] = useState('')
	const [phone, setPhone] = useState('')
	const [address1, setAddress1] = useState('')
	const [state, setState] = useState('')
	const [city, setCity] = useState('')
	const [zip, setZip] = useState('')
	const [addressArea, setAddressArea] = useState(false)
	const [isSubmitted, setIsSubmitted] = useState(false)
	const [isDuplicate, setIsDuplicate] = useState(false)
	const [loading, setLoading] = useState(false)

	const handleSaveUserData = (e) => {
		e.preventDefault()
		if(firstName && lastName && EmailValidator.validate(email) && phone) {
			if(Number(phone) && phone.length === 10 && !phone.startsWith(1)) {
				setAddressArea(true)
			} else {
				document.querySelector('.phone').classList.remove('normal')
				document.querySelector('.phone').classList.add('error')
			}
		} else {
			document.querySelectorAll('input').forEach(input => {
				input.classList.remove('normal')
				input.classList.add('error')
			})
		}
	}
	
	const handleFormOnSubmit = (e) => {
		e.preventDefault()
		setLoading(true)
		if(address1 && state && city && zip) {
			const config = {
				url: process.env.REACT_APP_SEND_FORM_WEBHOOK,
				method: 'POST',
				data: JSON.stringify({
					firstName: firstName,
					lastName: lastName,
					emailAddress: email,
					phoneNumber: phone,
					address1: address1,
					city: city,
					state: state,
					postalCode: zip,
					campaignId: process.env.REACT_APP_CAMPAIGN_ID,
					loginId: process.env.REACT_APP_LOGIN_ID,
					password: process.env.REACT_APP_PASSWORD,
				})
			}
			axios(config).then((res) => {
				if(res.data === 'SUCCESS') {
					setLoading(false)
					setIsSubmitted(true)
					setTimeout(() => {
						handleRedirect()
					}, 3000)
				} else {
					setLoading(false)
					setIsSubmitted(true)
					setIsDuplicate(true)
				}
			})
		} else {
			setLoading(false)
			document.querySelectorAll('input').forEach(input => {
				input.classList.remove('normal')
				input.classList.add('error')
			})
		}
	}

	useEffect(() => {
		document.querySelectorAll('input').forEach(input => {
			input.classList.remove('error')
			input.classList.add('normal')
		})
	}, [firstName, lastName, email, phone])

	const handleRedirect = () => {
		window.top.location = 'https://vividhearingaid.com/thankyou.html'
	}

	return (
		<div className="form">
			<>
			{!loading ? 
					<>
						{!addressArea && <span className="form-title">
							TRY RISK FREE FOR 45 DAYS
							<br />
							payments as low as $70/mo*
						</span>}
						<form className="form__container">
							{!addressArea ?
								<>
								<div className="name">
									<input type="text" className="first_name" name='firstName' placeholder='First Name' value={firstName} onChange={e => setFirstName(e.target.value)} />
									<input type="text" className="last_name" name='lastName' placeholder='Last Name' value={lastName} onChange={e => setLastName(e.target.value)}/>
								</div>
								<input type='email' className="email" name='emailAddress' placeholder='Email' value={email} onChange={e => setEmail(e.target.value)}/>
								<input type='number' className="phone" name='phoneNumber' placeholder='Phone'value={phone} onChange={e => setPhone(e.target.value)}/>
								<button className="next-button" onClick={handleSaveUserData}>Yes, start risk free trial</button>
								</> :
								<>
									{!isSubmitted ?
										<>
										<span className="address-area-title">Where should we ship your hearing aids?</span>
										<input type="text" className="address-line" name='address1' placeholder='Address' value={address1} onChange={e => setAddress1(e.target.value)} autoFocus/>
											<input type="text" className="city" name='city' placeholder='City' value={city} onChange={e => setCity(e.target.value)}/>
										<div className='city-zip'>
										<input type="text" className="state" name='state' placeholder='State' value={state} onChange={e => setState(e.target.value)}/>
											<input type="text" className="zip" name='postalCode' placeholder='Zip Code' value={zip} onChange={e => setZip(e.target.value)}/>
										</div>
										<button className="next-button" onClick={handleFormOnSubmit}>Submit</button>
										</> :
										<div className="form-submitted">
												{isDuplicate ?
														<div className="message">
															You've already submitted the form!
														</div> :
														<div className="message">
															Thank you. <br /> We will be contacting you shortly to confirm your order
														</div>
												}
										</div>
									}
								</>
							}
							{!isSubmitted &&
							<div className="disclaimer">
								I give Vivid Hear my consent to use automated technology to call or text me on my mobile phone or landline. Read our <a href='http://vividhearingaid.com/privacy.html'>privacy policy</a> *Financing for monthly payments are subject to approval and based on credit.
							</div>}
						</form>
							</> :
							<div className="loading">Please wait...</div>
						}
			</>
		</div>
	)

}

export default Form